import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { DamagedProductDetails } from "../../inventory.types";
import { ApiRoutesInventory } from "./../../constants";

export const requestGetDamagedItem = async (
  damagedItemId: string
): Promise<DamagedProductDetails> => {
  return await instance.get(
    buildUrl(ApiRoutesInventory.DamagedItem, damagedItemId)
  );
};
